import React from 'react';
import axios from 'axios';
import TitleAudio from './Audio';

const { parseString } = require('xml2js');

export function objToForm(data = {}) {
    let newData = new window.FormData();
    Object.keys(data).forEach((key) => {
        newData.append(key, data[key]);
    });
    return newData;
}

export const parseXML = (stringXML = '') => {
    return new Promise((resolve, reject) => {
        parseString(stringXML, (err, data) => {
            if (data) return resolve(data);
            if (err) return reject(err);
        });
    });
};

export const addFile = (titleID, file, fileData = {}, progress = () => {}) => {
    return axios
        .request({
            url: `${process.env.REACT_APP_API_URL}/authorized/titles/${titleID}/assets`,
            method: 'POST',
            data: {
                filenames: [
                    {
                        filename: file.name,
                        ...fileData
                    }
                ]
            }
        })
        .then((resp) => {
            return Promise.all(
                Object.keys(resp.data.files).map((key) => {
                    let { fields, url } = resp.data.files[key];
                    fields['Content-Type'] = file.type;
                    fields['X-Amz-Signature'] = fields.signature;
                    fields.file = file;
                    return axios.request({
                        url,
                        method: 'POST',
                        data: objToForm(fields),
                        onUploadProgress: progress
                    });
                })
            ).then(() => resp.data.files);
        });
};

export const uploadTitleAsset = (assetId, type, files = [], filedata = [], progress = () => {}) => {
    let filenames = files.map((file) => {
        return {
            assettype: type,
            filename: file.name
        };
    });
    return axios
        .request({
            url: `${process.env.REACT_APP_API_URL}/authorized/titles/${assetId}/assets`,
            method: 'POST',
            data: {
                filenames: filenames
            },
            onUploadProgress: (event) => {
                progress(event, assetId);
            }
        })
        .then((resp) => {
            return Promise.all(
                Object.keys(resp.data.files).map((key) => {
                    let file = files.find((f) => f.name === key);
                    let { fields, url } = resp.data.files[key];
                    fields['Content-Type'] = file.type;
                    fields['X-Amz-Signature'] = fields.signature;
                    fields.file = file;
                    return axios.request({
                        url,
                        method: 'POST',
                        data: objToForm(fields)
                    });
                })
            ).then(() => resp.data.files);
        });
};

export const deleteAsset = (id) => {
    return axios.request({
        url: `/authorized/assets/${id}`,
        method: 'DELETE'
    });
};

const TitleAssets = () => {
    return (
        <div className="row">
            <div className="col-xs-12 col-xl-9">
                <TitleAudio />
            </div>
        </div>
    );
};

export default TitleAssets;
